// extracted by mini-css-extract-plugin
export default {"Mark":"Mark_Mark__imlOl"};